import { Badge, Box, Flex, ListItem, Stack, Text, VStack } from '@chakra-ui/react';
import { TiArrowRight } from 'react-icons/ti';
import { badgeColor } from '../../../../../utils/badgeFunction';
import { ISimpleResource } from '../../../../../services/hooks/Resources/useRequestResources';
import { useNavigate } from 'react-router-dom';
import { memo } from 'react';

interface IOwnProps {
  data: ISimpleResource;
  selectiveProcessId: string;
}

const ListItemResource: React.FC<IOwnProps> = ({ data, selectiveProcessId = '' }) => {
  const navigate = useNavigate();

  return (
    <ListItem ml={3} pl={0}>
      <Flex align="center" justify="space-between">
        <Stack gap={0}>
          <Flex alignItems="center" gap={2}>
            <Box>
              <TiArrowRight color="#0064de" size={20} />
            </Box>
            <Text
              fontSize="sm"
              cursor="pointer"
              onClick={() => {
                navigate(`/painel/recursos/mostrar-mais/${data.resource_id}?selective_process=${selectiveProcessId}`);
              }}
              color="colorLink"
            >
              {data?.period_identification || 'Nao informado'} {'  '}
            </Text>
          </Flex>
          <VStack align="initial" pl={7} gap={2}>
            {data.period && (
              <Text as="span" fontSize="x-small" color="#afafaf" fontWeight="bold">
                {data?.period}
              </Text>
            )}
            <Badge
              fontSize={'9px'}
              borderRadius={4}
              textAlign="center"
              lineHeight="normal"
              p={'4px'}
              w="fit-content"
              bg={badgeColor(data?.resource_is_open)?.bgColor}
              color={badgeColor(data?.resource_is_open)?.color}
            >
              {data?.resource_is_open}
            </Badge>
          </VStack>
        </Stack>
      </Flex>
    </ListItem>
  );
};

export default memo(ListItemResource);
